import React from 'react'
import PropTypes from 'prop-types'
import VideoPlayerIcon from '../../icons/VideoPlayerIcon'
import Analytics from '../../helpers/media-gallery.tracking'

import * as Styled from './VideoPlayer.styles'

class VideoPlayer extends React.Component {
  constructor(props) {
    super(props)

    this.videoRef = React.createRef()

    this.state = {
      videoPlaying: false
    }
  }

  playVideo = () => {
    const { videoPlaying } = this.state
    if (this.videoRef.current) {
      this.videoRef.current.play()
    }
    this.setState(() => ({
      videoPlaying: !videoPlaying
    }))
  }

  trackVideoPlay = () => {
    Analytics.fire(
      this.props.index,
      'mainVideoPlay',
      Analytics.componentIdFromMediaSource(this.props.thumbnail),
      window
    )
    this.setState(() => ({
      videoPlaying: true
    }))
  }

  trackVideoPause = () => {
    Analytics.fire(
      this.props.index,
      'mainVideoPause',
      Analytics.componentIdFromMediaSource(this.props.thumbnail),
      window
    )

    this.setState(() => ({
      videoPlaying: false
    }))
  }

  renderControls = () => {
    const { isMobile } = this.props
    const { videoPlaying } = this.state

    if (isMobile) {
      if (videoPlaying) {
        return true
      }
      return false
    }
    return true
  }

  render() {
    const { videoPlaying } = this.state
    const { thumbnail, videoUri, refInView, isInModal } = this.props

    return (
      <Styled.Container ref={refInView}>
        <Styled.PlayButtonContainer
          playing={videoPlaying}
          tabindex='0'
          data-test='component-media-gallery-video-play-button'
          onClick={() => this.playVideo()}
          aria-label='play'
        >
          <VideoPlayerIcon />
        </Styled.PlayButtonContainer>
        <Styled.Video
          // Classname is needed for pausing the video when changing slide from the main MediaGallery component
          className={videoPlaying ? 'MediaGallery_video-player-playing' : 'MediaGallery_video-player'}
          controls={this.renderControls()}
          poster={thumbnail}
          preload='none'
          ref={this.videoRef}
          width='100%'
          height='100%'
          onPlay={this.trackVideoPlay}
          onPause={this.trackVideoPause}
          isInModal={isInModal}
        >
          <source src={`https:${videoUri}`} type='video/mp4' />
          <track kind='captions' />
        </Styled.Video>
      </Styled.Container>
    )
  }
}

VideoPlayer.propTypes = {
  videoUri: PropTypes.string.isRequired,
  thumbnail: PropTypes.string,
  index: PropTypes.number,
  isMobile: PropTypes.bool.isRequired
}
export default VideoPlayer
